import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./ViewSnapshotModal.module.css";

import SnapshotMembersList from "../SnapshotMembersList";
import { Modal } from "../../../shared/Modal";

/**
 * An interactive modal component used for viewing snapshot info in the snapshots tab of the events page
 */

export function ViewSnapshotModal({
  isOpen,
  onClose,
  onClick,
  snapshot,
  members,
  onDelete,
}) {
  const [_snapshot, setSnapshot] = useState({
    fileName: "N/A",
    date: "N/A",
    time: "",
    notes: "N/A",
    eventName: "N/A",
    totalUsers: 0,
  });
  const [_members, setMembers] = useState([]);
  const [_isOpen, setIsOpen] = useState(false);

  useMemo(() => {
    members && members !== null && setMembers(members);
  }, [members]);

  useMemo(() => {
    isOpen && isOpen !== null && setIsOpen(isOpen);
  }, [isOpen]);

  useMemo(() => {
    // null checking
    if (snapshot && snapshot !== null)
      setSnapshot((prev) => ({
        fileName:
          snapshot.fileName && snapshot.fileName !== null
            ? snapshot.fileName
            : prev.fileName,
        date:
          snapshot.date && snapshot.date !== null ? snapshot.date : prev.date,
        time:
          snapshot.time && snapshot.time !== null ? snapshot.time : prev.time,
        notes:
          snapshot.notes && snapshot.notes !== null
            ? snapshot.notes
            : prev.notes,
        eventName:
          snapshot.eventName && snapshot.eventName !== null
            ? snapshot.eventName
            : prev.eventName,
        totalUsers:
          snapshot.totalUsers && snapshot.totalUsers !== null
            ? snapshot.totalUsers
            : prev.totalUsers,
      }));
  }, [snapshot]);

  const handleClose = () => {
    onClose();
    setIsOpen(false);
  };

  return (
    <div className={styles.container}>
      <Modal
        isOpen={_isOpen}
        title="EVENT GROUP MEMBERS"
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
        children={
          <>
            <div className={styles.snapshotInfoRow}>
              <div className={styles.snapshotInfoItem}>
                <label>File Name</label>
                <span>{_snapshot.fileName}</span>
              </div>
              <div className={styles.snapshotInfoItem}>
                <label>Event Name</label>
                <span>{_snapshot.eventName}</span>
              </div>
            </div>
            <div className={styles.snapshotInfoRow}>
              <div className={styles.snapshotInfoItem}>
                <label>Created On</label>
                <span>
                  {_snapshot.date} {_snapshot.time}
                </span>
              </div>
              <div className={styles.snapshotInfoItem}>
                <label>Total Users</label>
                <span>{_snapshot.totalUsers}</span>
              </div>
            </div>

            <div className={styles.snapshotInfoRow}>
              <div className={styles.snapshotInfoItem}>
                <label>Notes</label>
                <span>{_snapshot.notes}</span>
              </div>
            </div>

            <div className={styles.snapshotInfoRow}>
              <div className={styles.listContainer}>
                <SnapshotMembersList snapshotMembers={_members} />
              </div>
            </div>

            <div className={styles.snapshotInfoRow}>
              <div>
                <button className={styles.delete} onClick={onDelete}>
                  DELETE SNAPSHOT
                </button>
              </div>
              <div className={styles.rightButtons}>
                <button className={styles.generate} onClick={onClick}>
                  GENERATE REPORT
                </button>
                <button className={styles.close} onClick={handleClose}>
                  CLOSE
                </button>
              </div>
            </div>
          </>
        }
      />
    </div>
  );
}

ViewSnapshotModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  snapshot: PropTypes.shape({
    fileName: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    notes: PropTypes.string,
    eventName: PropTypes.string,
    totalUsers: PropTypes.number,
  }),
  members: PropTypes.arrayOf(PropTypes.object),
};

ViewSnapshotModal.defaultProps = {
  snapshot: {},
  members: [],
};
